import { Component } from '@angular/core';
import { Router, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { AuthService } from '../core/auth.service';
import { UserService } from '@core/user.service';
import { Library } from '@core/library';
import { pattern } from '@config/pattern';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

  registerForm: FormGroup;
  errorMessage = '';
  successMessage = '';
  formSubmitAttempt: boolean;

  constructor(
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    private library: Library,
  ) {
    this.createForm();
  }

  isFieldInvalid(field: string, typeError: string) {
    if (this.formSubmitAttempt && this.registerForm.get(field).invalid) {
        return this.registerForm.get(field).hasError(typeError);
    }

    if (this.registerForm.get(field).invalid && (this.registerForm.get(field).touched)) {
      return this.registerForm.get(field).hasError(typeError);
    }
  }

  createForm() {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      email: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern(pattern.phoneNumber)
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6)
      ]),
      'password-verify': [''],
    });
  }

  tryRegister(value) {
    this.formSubmitAttempt = true;
    if (this.registerForm.invalid) {
      return;
    }

    this.library.showloading();
    this.authService.doRegister(value).then(res => {
      this.userService.register(res.user, value);
      this.errorMessage = '';
      this.successMessage = 'Your account has been created';
      this.router.navigate(['/order']);
    }, err => {
      console.log(err);
      this.errorMessage = err.message;
      this.successMessage = '';
    }).finally(() => {
      this.library.hideloading();
    });
  }

}
